export default "__VITE_ASSET__5183af67__"